function Sidebar(el) {
  var location = window.location.href;
  var url = new URL(location);
  var ref = url.searchParams.get('ref');

  if (ref === 'sidebar') {
    var main = document.querySelector('.blog-wrapper__main');

    if (main) {
      main.scrollIntoView();
    }
  }
}

module.exports = Sidebar;
